import React from 'react';
import { Route, Navigate, Routes } from 'react-router';
import Auth from '../Auth/Auth';
import Registration from '../Registration/Registration';
import { useLocation } from 'react-router-dom';

const RegistrationAuthPage = ({ isRegistration }) => {
  const location = useLocation()
  const currentLocation = `${window.location.pathname}${window.location.search}`
  const isStorageNeeded = currentLocation !== '/login' && currentLocation !== '/registration'
  if (isStorageNeeded) {
    localStorage.setItem('path1', currentLocation)
  }

  if(isRegistration && !location.pathname.includes('registration')){
    return <Navigate to="/registration"/>
  }

  if(!isRegistration && !location.pathname.includes('login')){
    return <Navigate to="/login"/>
  }

  return (
    <Routes>
      <Route path='/login' element={<Auth/>}/>
      <Route path='/registration' element={<Registration/>}/>
      <Route path='*' element={<Navigate to={{
        pathname: isRegistration ? '/registration' : '/login',
        state: {refferrer: currentLocation}
      }} />}/>
    </Routes>
  );
}

export default RegistrationAuthPage;
